import { AxiosInstance } from './auth/AxiosInstance';

// Get user orders (supports filtering by status and type)
export const getUserOrders = async (params = {}) => {
  const { data } = await AxiosInstance.get('/orders', { params });
  return data;
};

// Get a specific order by ID
export const getOrderById = async (orderId) => {
  const { data } = await AxiosInstance.get(`/orders/${orderId}`);
  return data;
};

// Update order status (Admin/Creator)
export const updateOrderStatus = async (orderId, status) => {
  const { data } = await AxiosInstance.patch(`/orders/${orderId}/status`, { status });
  return data;
};

// Cancel an order (Admin/Client)
export const cancelOrder = async (orderId, reason) => {
  const { data } = await AxiosInstance.post(`/orders/${orderId}/cancel`, { reason });
  return data;
};

// Admin only - get all orders
export const getAllOrdersAdmin = async (params = {}) => {
  const { data } = await AxiosInstance.get('/orders/admin/all', { params });
  return data;
};
// Admin only - extend order delivery date
export const extendOrderDelivery = async (orderId, newDeliveryDate, reason) => {
  const { data } = await AxiosInstance.patch(`/orders/${orderId}/extend`, { newDeliveryDate, reason });
  return data;
};

// Admin only - update order Hellocians
export const updateOrderHellocians = async (orderId, hellocianIds) => {
  const { data } = await AxiosInstance.patch(`/orders/${orderId}/hellocians`, { hellocianIds });
  return data;
};

// Admin only - remind client for review
export const remindReview = async (orderId) => {
  const { data } = await AxiosInstance.post(`/orders/${orderId}/remind-review`);
  return data;
};

// Admin only - request additional payment
export const requestAdditionalPayment = async (orderId, amount, description) => {
  const { data } = await AxiosInstance.post(`/orders/${orderId}/request-additional-payment`, { amount, description });
  return data;
};

// Client - get activity stats
export const getClientActivityStats = async () => {
  const { data } = await AxiosInstance.get('/orders/client-activity-stats');
  return data;
};
